import React from 'react';
import { connect } from 'react-redux';
import isMobile from 'ismobilejs';

import { goTo } from '../tools';
import { movil } from '../app-movil';

const mapState = (state) => {
    return {
        paso: state.registro.paso
    };
}

const mapDispatch = (dispatch) => {
    return {
        pasoAnterior: () => {
            dispatch({ "type": "REGISTRO_PASO_ANTERIOR" });
        },
        enviarLogin: (oMensaje) => {
            dispatch({ "type": "ENVIAR_MENSAJE_MOVIL", "mensaje": oMensaje});
        }
    }
}

class Paso extends React.Component {
    state = {
        "images": [
            require("../img/poliza_activo.svg"),
            require("../img/datos_activo.svg"),
            "",
            require("../img/seguridad_activo.svg")
        ]
    }
    
    pasoAnterior = () => {
        if (this.props.paso == 0) {
            let mensaje = { "return": "login" };
        
            this.props.enviarLogin(mensaje);
            movil("registro", mensaje);
            
            goTo("login");
            //window.location.href = '/#!/login';
        } else {
            this.props.pasoAnterior();
            goTo("registro");
            //window.location.href = '/#!/registro';
        }
    }
    
    render() {
        return (
            <div className="pasos-wrap">
                {  isMobile.any == true && this.props.paso > 0 && this.props.paso < 2 &&
                    <a onClick={this.pasoAnterior} className="pull-left">
                        <img src={ require("../img/arrow-back.png") } alt="" />
                    </a>
                }
                
                {  isMobile.any == false && this.props.paso < 2 &&
                    <a onClick={this.pasoAnterior} className="pull-left">
                        <img src={ require("../img/arrow-back.png") } alt="" />
                    </a>
                }
                
                { this.props.paso != 2 &&
                    <img src={ this.state.images[this.props.paso] } alt="" />
                }
                
                <div style={{"display": "none"}}>
                    {this.state.images.map((item, i) => <img src={item} key={i}/> )}
                </div>
            </div>            
        );
    }
}

export default connect(mapState, mapDispatch)(Paso);


// WEBPACK FOOTER //
// ./src/registro/paso.cmpt.js